<!-- eslint-disable -->
<template lang="pug">
    .play-box
        template(v-if='!isLoading')
            game-header(
                :time='getTime'
                :slug='type'
                :game-type='parameters && parameters.courseType'
                @soundStateChanged="headerKey = !headerKey",
                :key="headerKey",
                :show-rounds="showRounds()"
                :amount-of-rounds="parameters.numOfExamples"
                :amount-of-played-rounds="amountOfExamples"
                :is-homework="!!exerciseId"
            )
            .chains-game-container__interactive-place
                chain(
                    v-if='!gameFinished && !isNextExampleButtonShown'
                    :chain='chain'
                    :game-started='gameStarted'
                    :game-mode='parameters.mode'
                    :memorized='memorized'
                    :helper-mode-on='helperModeOn'
                    @processReply='processReply'
                    @displayPlayButton='showPlayButton = true'
                    @dropItemInChain='dropItemInChain'
                    @dragStarted="isDragging = true"
                    @dragEnded="isDragging = false"
                    :links-type='typeOfLinksInChain'
                    :drag-started='dragStarted'
                )
                .chains__buttons-container(v-if='!gameFinished && !isNextExampleButtonShown')
                    cs-button.chains__button(
                        v-if='showMemorizedButton'
                        color="blue"
                        @click='handleMemorized'
                        v-focus=''
                    )
                        | {{ memorizedButtonName }}
                    cs-button.chains__button(
                        v-if='showStartGameButton'
                        color="blue"
                        @click='startGame'
                    )
                        | {{ $i18n.t('trainer.trainer_browseGames_play') }}
                    cs-button.chains__button(
                        v-if='gameStarted && !helperModeOn'
                        color="blue"
                        :disabled='disableReplyButton'
                        @click='processReply'
                    )
                        | {{ $i18n.t('trainer.trainer_gamePlayBox_reply') }}
                    cs-button.chains__button(
                        v-if="gameStarted && typeOfLinksInChain !== 'image' && !helperModeOn && !isOlympiad"
                        color="blue"
                        @click='showCorrectAnswers'
                        :disabled='!disableReplyButton'
                    )
                        | {{ $i18n.t('trainer.trainer_gamePlayBox_forgot') }}
                    cs-button.chains__button(
                        v-if='helperModeOn'
                        color="blue"
                        @click='processReply'
                    )
                        | {{ memorizedButtonName }}
                drop.chains__answer-container(
                    @drop='dropItemInAnswersBox'
                    v-if='!gameFinished && showAnswersContainer'
                )
                    answer-container(
                        v-show="displayAnswersContainer"
                        :answers='itemsForAnswersBox'
                        :game-started='gameStarted'
                        :links-type='typeOfLinksInChain'
                        @dragStarted='dragStarted = true'
                        @dragEnded='dragStarted = false'
                    )
                fireworks(v-if='gameFinished && !isOlympiad && !prepareForGame' :is-mobile='isMobile')
                .chains-game-container__result-container(
                    v-if='(gameFinished || isNextExampleButtonShown) && !isOlympiad'
                )
                    result-image.chains-game-container__result-image(status='success')
                    result-buttons(
                        :exercise-id="exerciseId"
                        games-type="fastReading"
                        show-restart-button
                        @restartGame="restartGame"
                    )
                        template(slot="mainButton")
                            cs-button(
                                v-if="isNextExampleButtonShown",
                                color="blue"
                                @click='getExample'
                                v-focus=''
                            )
                                | {{ $i18n.t('trainer.trainer_gamePlayBox_playOn') }}
                        slot
        cs-loader(v-else='')
</template>

<script>
    /*eslint-disable*/
    import Chain from "./Chain.vue";
    import ChainsGameItemsApi from "../../../../api/games/chainsBonusGameApi";
    import { Drop } from 'vue-drag-drop';
    import _ from "lodash";
    import playBoxGameMixin from '../../../../utils/trainer/playBoxGameMixin.js';
    import olympiadAnswerTimerMixin from '../../../../utils/olympiads/olympiadAnswerTimerMixin.js';
    import AnswerContainer from './AnswerContainer.vue';

    const CORRECT_LINK = 'correct-link';
    const DEFAULT_VOLUME = 0.6;

    function DEFAULT_DATA () {
        return {
            typeOfLinksInChain: '',
            showPlayButton: false,
            chainOfAttempts: [[]],
            allInputsAreFilled: false,
            dragStarted: false,
            helperModeOn: false,
            prepareForGame: true,
            isNextExampleButtonShown: false,
            amountOfExamples: 0,
            hideGameHeader: false,
            isAttemptCorrect: false,
            itemsForAnswersBox: [],
            prevSubGroup: 0,
            chain: [],
            correctChain: [],
            memorized: false,
            isDragging: false,
        }
    }

    export default {
        mixins: [playBoxGameMixin, olympiadAnswerTimerMixin],
        data () {
            return DEFAULT_DATA();
        },
        watch: {
            chain: {
                handler (chain) {
                    if (this.typeOfLinksInChain !== 'image') {
                        let allInputsAreFilled = _.find(chain, link => _.trim(link.value).length === 0);
                        this.allInputsAreFilled = allInputsAreFilled === undefined;
                    }
                },
                deep: true,
                immediate: true
            },
        },
        methods: {
            fetchData () {
                this.getExercise()
                    .then(() => {
                        this.getExample();
                        this.registerSounds();

                        this.beforeStart();
                    })
                    .catch(e => {
                        this.isLoading = false;
                        this.$toasted.error(this.$root.$t('errors.getting_level'));
                        this.$router.push({ name: 'dashboard' });
                    })
            },
            beforeStart () {
                this.prepareForGame = false;
                if (!this.timer) {
                    this.setTimer();
                }
                this.parameters.withTime && !this.amountOfExamples && (this.showNewLink());
            },
            getExample () {
                this.isLoading = true;
                if (this.isAttemptCorrect && !this.isOlympiad) {
                    this.chainOfAttempts.push([]);
                    this.sendStat();
                }
                let paramsForRequest = {
                    amountOfLinks: this.parameters.amountOfLinks,
                    group: this.parameters.imageType,
                    subgroup: this.prevSubGroup,
                };
                ChainsGameItemsApi.getChainByRequest(paramsForRequest)
                    .then(({chain, subgroup}) => {
                        this.prevSubGroup = subgroup;
                        this.chain = chain.map(value => ({ value, type: 'image' }));
                        this.correctChain = _.cloneDeep(this.chain);
                        this.typeOfLinksInChain = 'image';
                        this.isLoading = false;
                    })
                    .catch(err => this.showErrorMessage(err));
                if (!this.timer && !this.prepareForGame) {
                    this.setTimer();
                }
                this.isNextExampleButtonShown = false;
                if (this.parameters.withTime && this.amountOfExamples) {
                    this.gameStarted = false;
                    this.showNewLink();
                }
            },
            refreshGameStatBeforeSend () {
                this.gameStat.chainOfAttempts = this.chainOfAttempts;
                this.gameStat.attempts = this.isAttemptCorrect
                    ? this.chainOfAttempts[this.amountOfExamples - 1].length
                    : this.chainOfAttempts[this.amountOfExamples].length;
                this.gameStat.answers = this.amountOfExamples;
                this.gameStat.percent = this.calculatePercent();
                this.gameStat.isCompleted = this.gameFinished;
                this.gameStat.executionTime = this.time;
                this.gameStat.isCorrect = true;
                this.gameStat.parameters = _.cloneDeep(this.parameters);
            },
            calculatePercent () {
                let total = this.goodAnswers + this.badAnswers;
                if (total > 0) {
                    return parseInt(this.goodAnswers / (total) * 100);
                }
                return 0;
            },
            handleMemorized () {
                (this.parameters.mode === 'allTogether' || this.helperModeOn) ? this.startGame() : this.memorized = !this.memorized;
            },
            processReply () {
                this.stopAnswerTimer();
                let elemOfExampleAttempts = {
                    good: 0,
                    bad: 0
                };
                for (let index = 0; index < this.chain.length; index++) {
                    if (this.chain[index].type !== CORRECT_LINK) {
                        if (!this.chain[index].helpMarker && (this.correctChain[index].value === this.chain[index].value)) {
                            this.correctChain[index].type = CORRECT_LINK;
                            this.chain[index].type = CORRECT_LINK;
                            elemOfExampleAttempts.good++;
                        } else {
                            elemOfExampleAttempts.bad++;
                        }
                    }
                }
                this.chainOfAttempts[this.amountOfExamples].push(elemOfExampleAttempts);
                this.helperModeOn = false;
                if (this.chain.filter(link => link.type === CORRECT_LINK).length === this.correctChain.length) {
                    this.amountOfExamples++;
                    this.isAttemptCorrect = true;
                    this.hideGameHeader = true;
                    if (this.amountOfExamples === this.parameters.numOfExamples) {
                        this.chainDone();
                        return;
                    }
                    if (!this.$offline && (this.user.type === 'student' || this.user.type === 'olympiads-student')) {
                        this.sendStat();
                    }
                    this.resetData();
                    if  (this.isOlympiad) {
                        this.chainOfAttempts.push([]);
                        this.isNextExampleButtonShown = false;
                        this.getExample();
                    }
                    return;
                }
                if (this.isOlympiad) {
                    this.resetData();
                    this.amountOfExamples++;
                    this.chainOfAttempts.push([]);
                    this.isNextExampleButtonShown = false;
                    this.isAttemptCorrect = false;
                    if (this.amountOfExamples === this.parameters.numOfExamples) {
                        this.chainDone();
                        return;
                    }
                    this.getExample();
                }
                this.dropChainInAnswerBox();
                if (!this.$offline && (this.user.type === 'student' || this.user.type === 'olympiads-student')) {
                    this.isAttemptCorrect = false;
                    this.sendStat();
                }
            },
            resetData () {
                this.isNextExampleButtonShown = true;
                this.hideGameHeader = false;
                this.gameStarted = false;
                this.memorized = false;
                this.stopTimer();
                this.timer = null;
                this.itemsForAnswersBox = [];
                this.chain = [];
                this.correctChain = [];
                if (this.answerTimer) {
                    clearInterval(this.answerTimer);
                    this.answerTimer = null;
                }
            },
            chainDone () {
                if (!this.isOlympiad) {
                    this.soundInstance = this.$createjs.Sound.play("gameDone");
                    this.soundInstance.volume = DEFAULT_VOLUME;
                }
                this.gameFinished = true;
                this.sendStat();
            },
            startGame () {
                this.memorized = true;
                this.gameStarted = true;
                this.showPlayButton = false;
                if (this.answerDuration) {
                    this.startAnswerTimer();
                }
                this.dropChainInAnswerBox();
            },
            showNewLink () {
                if (!this.showPlayButton && !this.gameStarted) {
                    setTimeout(() => {
                        this.handleMemorized();
                        this.showNewLink();
                    }, this.parameters.showTime * 1000)
                } else {
                    this.startGame();
                }
            },
            dropChainInAnswerBox () {
                this.itemsForAnswersBox = _.shuffle(_.cloneDeep(this.correctChain.filter(item => item.type !== CORRECT_LINK)));
                let typeForEmptyCell = this.parameters.viewType === 'image' ? 'dropZone' : 'textInput';
                this.chain = this.chain.map(link => {
                    if (link.type !== CORRECT_LINK) {
                        link = {
                            type: typeForEmptyCell,
                            value: ''
                        };
                    }
                    return link;
                });
                this.$nextTick(this.shakeAnswerBlocks);
            },
            shakeAnswerBlocks () {
                let answerBlocks = document.getElementsByClassName('answer');
                let amount = answerBlocks.length;
                let timeouts = [];
                for (let i = 0; i < amount; i++) {
                    timeouts.push(setTimeout(() => {
                        answerBlocks[i].classList.add('shake');
                    }, i * 100));
                }
                setTimeout(() => {
                    for(let j = 0; j < timeouts.length; j++) {
                        clearTimeout(timeouts[j]);
                    }
                    for (let i = 0; i < amount; i++) {
                        if (answerBlocks[i]) {
                            answerBlocks[i].classList.remove('shake');
                        }
                    }
                }, 2000)
            },
            dropItemInChain (index) {
                this.itemsForAnswersBox.splice(index, 1);
                this.isDragging = false;
            },
            dropItemInAnswersBox (link) {
                if (link && link.from !== 'answers-box') {
                    let item = _.cloneDeep(link.item);
                    let dragEvent = arguments[arguments.length - 1];
                    let toDropIndex = dragEvent.srcElement.dataset.index;
                    if (toDropIndex) {
                        this.itemsForAnswersBox.splice(toDropIndex, 0, item);
                    } else {
                        if (dragEvent.srcElement.childElementCount) {
                            toDropIndex = dragEvent.srcElement.children[0].dataset.index;
                            toDropIndex && this.itemsForAnswersBox.splice(toDropIndex, 0, item);
                        }
                        !toDropIndex && this.itemsForAnswersBox.push(item);
                    }
                    this.$set(this.chain, link.index, {type: 'dropZone'});
                }
            },
            showCorrectAnswers () {
                for (let index = 0; index < this.chain.length; index++) {
                    if (!_.trim(this.chain[index].value)) {
                        this.$set(this.chain, index, _.cloneDeep(this.correctChain[index]));
                        this.chain[index].helpMarker = true;
                    } else {
                        this.chain[index].type = this.correctChain[index].type;
                        this.chain[index].helpMarker = false;
                    }
                }
                this.helperModeOn = true;
            },
            showRounds() {
                return window.innerWidth > 767
            },
            beforeGameRestart() {
                this.resetData();
                Object.assign(this, DEFAULT_DATA());
            }
        },
        computed: {
            goodAnswers () {
                let count = 0;
                this.chainOfAttempts.forEach(example => {
                    example.forEach(attempt => count += attempt.good);
                });
                return count;
            },
            badAnswers () {
                let count = 0;
                this.chainOfAttempts.forEach(example => {
                    example.forEach(attempt => count += attempt.bad);
                });
                return count;
            },
            memorizedButtonName () {
                return this.$i18n.t('trainer.trainer_gamePlayBox_memorizedButton', {
                    mode: this.parameters.mode === 'allTogether' || this.helperModeOn
                        ? this.$i18n.t('trainer.trainer_gamePlayBox_memorizedButton_all')
                        : this.$i18n.t('trainer.trainer_gamePlayBox_memorizedButton_link')
                });
            },
            showMemorizedButton () {
                return (!this.memorized || !this.gameStarted) && !this.showPlayButton && !this.parameters.withTime && !this.isNextExampleButtonShown;
            },
            allLinksNotSettled () {
                return this.typeOfLinksInChain === 'image' ? this.itemsForAnswersBox.length !== 0 : false;
            },
            disableReplyButton () {
                return this.allLinksNotSettled || !this.allInputsAreFilled;
            },
            showStartGameButton () {
                return this.showPlayButton && !this.gameStarted && !this.parameters.withTime;
            },
            showAnswersContainer () {
                return this.typeOfLinksInChain === 'image' && this.gameStarted;
            },
        },
        components: {
            AnswerContainer,
            Chain,
            Drop,
        }
    }
</script>

<style scoped lang="scss">
    @import "@/assets/sass/games/playbox.scss";

    .chains-game-container__prepare-image {
        display: flex;
        flex-direction: column;
        flex-grow: 1;
        flex-shrink: 1;
        justify-content: center;
        align-items: center;
        @include inset-space($space-base);
    }

    .chains-game-container__prepare-text {
        font-family: Boomboom, serif;
        color: $color-brown-500;
        font-size: 30px;
        white-space: nowrap;
    }

    .chains-game-container_before-start {
        justify-content: space-around;
    }

    .chains-game-container__result-container {
        display: flex;
        flex-direction: column;
        align-items: center;
        height: 100%;
    }

    .chains-game-container__result-image {
        @include stack-space($space-base);
    }

    .chains-game-container__interactive-place {
        margin: 0;
        flex: 1 1 auto;
        width: 100%;
        min-height: 100%;
        display: inline-flex;
        justify-content: flex-start;
        flex-direction: column;
    }

    .chains__buttons-container {
        display: flex;
        justify-content: center;
        text-align: center;
        margin: 40px 0;
        :nth-child(2n) {
            margin-left: 20px;
        }
    }

    .chains__answer-container {
        display: flex;
        justify-content: center;
        flex: 1 1 auto;
        width: 100%;
    }

    .chains__link {
        @media screen and (max-width: 640px) {
            display: block;
            margin-bottom: 30px;
        }
        @include media($lg) {
            @include inline-space($space-small);
        }

        &:first-child {
            margin-right: 25px;
        }
    }

    .chains__button {
        @media screen and (max-width: 640px) {

        }
    }

    .play-box__buttons {
        display: flex;
        flex-direction: column;
        @include media($lg) {
            flex-direction: row;
        }
    }

    .play-box__button {
        margin: 20px 0;
        @include media($lg) {
            margin: 0 20px;
        }
    }

    .play-box__button:first-child {
        margin-top: 0;
        @include media($lg) {
            margin-left: 0;
        }
    }

    .play-box__button:last-child {
        margin-bottom: 0;
        @include media($lg) {
            margin-right: 0;
        }
    }

    @import '@/assets/sass/animations/shake.scss';
</style>
